// extracted by mini-css-extract-plugin
export default {"Root":"DateRangePicker_Root__mv1jv"};